import { IziToastSettings } from 'izitoast';

import Toast from './toast';
import { ToastType } from './tost-type.enum';

/**
 * Cria um toast e o exibe
 *
 * @param message Mensagem a ser exibida
 */
export default (message: string, type: ToastType, options?: IziToastSettings) => {
  new Toast(message, type, options).show();
};
